var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "checkout-form-group__fields" }, [
    _c(
      "div",
      { staticClass: "delivery-items" },
      _vm._l(_vm.deliveryItems, function (item) {
        return _c(
          "button",
          {
            key: "delivery_" + item.id,
            staticClass: "delivery-items__item delivery-item",
            class: { "delivery-item--selected": _vm.order.delivery == item.id },
            on: {
              click: function ($event) {
                return _vm.selectItem(item)
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "delivery-item__check",
                class: {
                  "delivery-item__check--checked":
                    _vm.order.delivery == item.id,
                },
              },
              [
                _vm.order.delivery == item.id
                  ? _c("i", {
                      staticClass:
                        "fa fa-circle-check delivery-item__check-icon",
                    })
                  : _c("i", { staticClass: "delivery-item__empty-check-icon" }),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "delivery-item__content" }, [
              _c("span", { staticClass: "delivery-item__header" }, [
                _c("span", { staticClass: "delivery-item__name" }, [
                  _vm._v(
                    "\n                     " +
                      _vm._s(item.name) +
                      "\n                 "
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "delivery-item__price" }, [
                  item.calculated_price
                    ? _c("span", [
                        _vm._v(_vm._s(item.calculated_price) + " руб."),
                      ])
                    : _c("span", [_vm._v("Без доплат")]),
                ]),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "delivery-item__about" }, [
                _vm._v(
                  "\n                 " +
                    _vm._s(item.help_text) +
                    "\n             "
                ),
              ]),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }